import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[9999998] flex items-center justify-center bg-white/60 backdrop-blur-sm"
}

import { isRouteLoading } from '@/composables/routeLoading'
import { enPrimeVueTranslations } from '@/locales/primeVue/en-primevue-translations'
import { esPrimeVueTranslations } from '@/locales/primeVue/es-primevue-translations'
import { ptPrimeVueTranslations } from '@/locales/primeVue/pt-primevue-translations'
import { Toast, usePrimeVue } from 'primevue'
import ProgressSpinner from 'primevue/progressspinner'
import { onMounted, onUnmounted, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'
import {
  showUnauthenticatedToast,
  clearToastRef,
  showNoValidClientToast,
  clearNoValidClientToastRef,
} from '@/composables/unauthenticatedToast'

import { useClientStore } from './stores/ClientStore'
import { useExportDataStore } from './stores/ExportDataStore'
import { useSignalRStore } from './stores/SignalRStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const exportDataStore = useExportDataStore()
const signalRStore = useSignalRStore()
const clientStore = useClientStore()
const toast = useToast()
const primeVue = usePrimeVue()
const { t } = useI18n()

const localePrimeVue = {
  pt: ptPrimeVueTranslations,
  es: esPrimeVueTranslations,
  en: enPrimeVueTranslations,
}

watch(showUnauthenticatedToast, (value) => {
  if (value) {
    toast.removeAllGroups()
    toast.add({
      severity: 'warn',
      summary: 'Não autenticado',
      detail: 'Você não está autenticado. Por favor, faça login novamente.',
      life: 7000,
    })
    clearToastRef()
  }
})

watch(showNoValidClientToast, (val) => {
  if (!val) return
  toast.add({
    severity: 'warn',
    summary: t('errors.noValidClient.title'),
    detail: t('errors.noValidClient.detail'),
    life: 5000,
  })
  clearNoValidClientToastRef()
})

let forceReloadTimer: ReturnType<typeof setTimeout> | null = null
const forceReloadClientHandler = () => {
  if (forceReloadTimer) return
  forceReloadTimer = setTimeout(() => {
    forceReloadTimer = null
    clientStore.loadClientsFromApi()
  }, 300)
}

onMounted(() => {
  signalRStore.startConnection().then(() => {
    exportDataStore.setupHubConnection()
  })

  window.addEventListener('force-reload-client', forceReloadClientHandler)

  const languageLocale = localStorage.getItem('language')?.replaceAll('"', '')

  primeVue.config.locale =
    localePrimeVue[languageLocale as keyof typeof localePrimeVue] || localePrimeVue.pt
})

onUnmounted(() => {
  window.removeEventListener('force-reload-client', forceReloadClientHandler)
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_component_router_view, {
      key: _unref(clientStore).clientChangeKey
    })),
    _createVNode(_unref(Toast), { pt: { detail: { class: 'whitespace-pre-line' } } }),
    _createVNode(_Transition, { name: "route-loading" }, {
      default: _withCtx(() => [
        (_unref(isRouteLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_unref(ProgressSpinner), {
                strokeWidth: "3",
                class: "h-16 w-16",
                pt: { circle: { style: 'stroke: #0ea5e9' } }
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})